import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

/**
 * Consistent empty state for lists and tables.
 *
 * Shown by the hosts only when a request succeeded but returned no rows
 * (loading is covered by the table skeletons). Optional CTA:
 *   <app-empty-state ctaKey="MENU.CAMPAIGNS_NEW" (ctaClick)="create()" />
 */
@Component({
  selector: "app-empty-state",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./empty-state.component.html",
  styleUrl: "./empty-state.component.scss",
})
export class EmptyStateComponent {
  @Input() titleKey = "EMPTY_STATE.TITLE";
  @Input() messageKey = "EMPTY_STATE.MESSAGE";
  /** Optional translate key for the primary action; hidden when absent. */
  @Input() ctaKey?: string;
  /** Tighter paddings for dense hosts (modals, small cards). */
  @Input() compact = false;
  @Output() ctaClick = new EventEmitter<void>();
}
